import { render, staticRenderFns } from "./ui-query-data.vue?vue&type=template&id=1a5280b6&scoped=true"
import script from "./ui-query-data.vue?vue&type=script&lang=js"
export * from "./ui-query-data.vue?vue&type=script&lang=js"
import style0 from "./ui-query-data.vue?vue&type=style&index=0&id=1a5280b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5280b6",
  null
  
)

export default component.exports